<div class="container bring-footer-forward">
    <div class="footer_padding">
        <footer>
            &copy;2011-{{currentYear}} The Vanguard Group, Inc. All rights reserved.
            <a c11n-link [routerLink]="'/terms' | langLink" [variant]="'secondary-independent'" [attr.aria-label]="'footer.terms_conditions_lowercase_attr' | translate">{{
                'footer.terms_conditions_lowercase' | translate
            }}</a> |
            <a c11n-link [routerLink]="'/privacy' | langLink" [variant]="'secondary-independent'" [attr.aria-label]="'footer.privacypolicy_attr' | translate">{{ 
                'footer.privacypolicy' | translate 
            }}</a> |
            <a c11n-link [routerLink]="'/studentprivacy' | langLink" [variant]="'secondary-independent'" [attr.aria-label]="'footer.studentprivacy_attr' | translate">{{ 
                'footer.studentprivacy' | translate 
            }}</a> |
            <a c11n-link [routerLink]="'/aboutus' | langLink" [queryParams]="{contact: 'true'}" [variant]="'secondary-independent'" [attr.aria-label]="'footer.contact_us_attr' | translate">{{ 
                'footer.contact_us' | translate 
            }}</a> |
            <a href="#" (click)="$event.preventDefault()" class="ot-sdk-show-settings c11n-link override-onetrust-style" [attr.aria-label]="'footer.manage_cookies_attr' | translate">{{ 
                'footer.manage_cookies' | translate 
            }}</a> |
            <a href="https://www.facebook.com/groups/myclassroomeconomy/"><img src="assets/images/icons/social-media-facebook.svg" width="20" height="20" title="Facebook Link" alt="Facebook" style="display: inline"></a>
        </footer>
    </div>
</div>
